module.exports = __webpack_public_path__ + "img/escalator-vert.e8c88260.png";